<template>
  <div class="dialog_warp">
    <div class="dialog_form">
      <div class="g-thing-tit flex-box">
        <div class="g-widths">
          <h4 class="">{{notifyInfo.notifyName}}</h4>
          <div class="flex-box">
            <p>发起人：{{notifyInfo.notifyCreateAdminName}}</p>
            <p>发起时间：{{notifyInfo.notifyCreateTime|datetimeType("yyyy-MM-dd hh:mm")}}</p>
          </div>
        </div>
        <el-tag>{{notifyInfo.notifyType|notifyType}}</el-tag>
      </div>
      <p class="g-contp" v-html="notifyInfo.notifyDes"></p>
      <ul>
        <li class="flex-box" v-for="(file,fileIndex) in fileList" :key="fileIndex"
            style="width: 250px; padding: 5px 15px;">
          <p class="ellipsis" style="flex: 1; color: rgb(0, 102, 255);" :title="file.notifyFileName">
            {{file.notifyFileName|empty}}</p>
          <i class="el-icon-download download-icon icon" style="color: #1396db;"
             @click="downloadFile(file,fileIndex)"></i>
        </li>
      </ul>
    </div>
    <div class="dialog_form" v-if="notifyInfo.notifyNecessityReply">
      <el-form>
        <el-form-item label="回复内容:" v-if="notifyInfo.notifyIsRead === 0">
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model.trim="conts" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="回复内容:" v-else>
          {{notifyInfo.notifyCompanyReply}}
        </el-form-item>
      </el-form>
    </div>
    <div class="text-center">
      <p style="margin-top: 10px;">
        <el-button size="small" class="f-search-btn" @click.stop="close() ">返回
        </el-button>

        <el-button size="small" class="f-search-btn g-success" type="success" v-if="notifyInfo.notifyIsRead === 0" @click.stop="submits()" :loading="submitLoading">我已确认
        </el-button>
        <!-- <el-button size="small" class="f-search-btn g-success" type="success" v-else @click.stop="close()">确认
        </el-button> -->

      </p>
    </div>
  </div>
</template>

<script>
  import * as global from '../config/mUtils'
  import * as getData from "../service/getData";
  export default {
    data() {
      return {
        notifyInfo: {},
        fileList: [],
        submitLoading: false,
        conts: '',
      }
    },
    created() {
    },
    mounted() {
      getData.findNotify(this.notifyId).then(res => {
        if (res.data.code == "success") {
          this.notifyInfo = res.data.data.notify;
          this.fileList = this.notifyInfo.notifyFileList ? this.notifyInfo.notifyFileList : [];
        } else {
          this.$message({
            message: res.data.message,
            type: "error"
          });
        }
      });

    },
    computed: {},
    props:['notifyId'],
    methods: {
      close(type) {
        if (type === 1) {
          this.$emit('init')
        } else {
          this.$emit('closeDialog')
        }
      },
      downloadFile(row, index) {
        if (!row.notifyFileUrl || !row.notifyFileName) {
          this.$message({
            type: "warning",
            message: "下载地址不存在！"
          });
          return;
        }
        if (row.notifyFileId) {
          window.location.href = `/company/notify/downloadFile?notifyFileId=${row.notifyFileId}`;
        } else {
          window.location.href = `/company/notify/downloadFile?notifyFileUrl=${row.notifyFileUrl}&notifyFileName=${row.notifyFileName}`;
        }
      },
      submits () {
        if (this.notifyInfo.notifyNecessityReply) {
          if (!this.conts) {
            this.$message.error('请填写回复内容！')
            return
          }
        }
        let info = {
          notifyId: this.notifyId,
          replyContent: this.conts
        }
        this.submitLoading = true
        getData.readConfirm(info).then(res => {
          this.submitLoading = false
          if (res.data.code === 1 || res.data.code === 'success') {
            this.$message.success('回复成功！');
            this.close(1)
          }
        }).catch(err => {
          this.submitLoading = false
          console.log(err)
        })
      }
    },
    components: {},
    watch: {},
    filters: {
      notifyType (val) {
        switch (val) {
          case 1:
            return '园区通知'
          case 2:
            return '政策通知'
          default:
            return '-'
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';


  .g-thing-tit {
    border-bottom: 1px solid #cccccc;

    .g-widths{
      width: calc(100% - 70px);
    }

    h4 {
      @include sc(16px, #333);
      line-height: 40px;
      font-weight: bold;
    }

    p {
      @include sc(12px, #666);
      line-height: 30px;
      margin-right: 20px;
    }
  }

  .g-contp {
    margin-top: 20px;
    line-height: 24px;
    @include sc(13px, #333);
    text-indent: 2em;
  }

  .dialog_form {
    padding: 20px;
  }

  .f-search-btn {
    width: $btnWid;
    border-radius: $radius;
  }


  .g-success {
    background: $button;
    border-color: $button;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/notification-details.vue